import { IconArrowRight, IconGreenCheck, IconVehicleMoto } from '../../../assets/icons'
import { OPTIONS_VEHICLE_TYPE_INFO_VEHICLE } from '../../../constants/vehicle'
import { formatDate } from '../../../helper/formatDate'
import iconBell from '../../../assets/icons/icon_bell.png'
import SafeImage from '../SafeImage'
import './index.scss'

const DEFAULT_VEHICLE_TYPE = 1

function getVehicleTypeInfo(vehicleType) {
  const safeVehicleType = Number(vehicleType)

  return (
    OPTIONS_VEHICLE_TYPE_INFO_VEHICLE.find((item) => Number(item.vehicleType) === safeVehicleType) ||
    OPTIONS_VEHICLE_TYPE_INFO_VEHICLE.find((item) => Number(item.vehicleType) === DEFAULT_VEHICLE_TYPE) ||
    {}
  )
}

export default function VehicleItem({
  key,
  className = '',
  vehicleType = DEFAULT_VEHICLE_TYPE,
  vehicleIdentity = '',
  isLoading = false,
  isRegisteredPackage = false,
  notifyEndDateTime = '',
  registeredPackageMode = 1,
  registeredPackageText = 'Đã đăng ký',
  productName = '',
  allowRenew = 0,
  onClick,
  onActionClick,
  onClickArrowRight
}) {
  if (isLoading) {
    return (
      <div className={`VehicleItem VehicleItem_skeleton ${className}`.trim()} aria-hidden="true" key={key}>
        <div className="VehicleItem_top">
          <div className="VehicleItem_top_left">
            <div className="VehicleItem_iconSkeleton" />
            <div className="VehicleItem_main">
              <div className="VehicleItem_vehicleIdentitySkeleton" />
              <div className="VehicleItem_registeredPackageSkeleton" />
            </div>
          </div>
          <div className="VehicleItem_arrowSkeleton" />
        </div>

        <div className="VehicleItem_action VehicleItem_action_skeleton">
          <div className="VehicleItem_actionTextSkeleton" />
          <div className="VehicleItem_actionButtonSkeleton" />
        </div>
      </div>
    )
  }

  const vehicleTypeInfo = getVehicleTypeInfo(vehicleType)
  const VehicleIcon = vehicleTypeInfo?.IconComponent || IconVehicleMoto
  const currentRegisteredPackageMode = registeredPackageMode === 2 ? 2 : 1
  const isRegistered = !!isRegisteredPackage
  const isAutoRenew = Number(allowRenew) === 1 || allowRenew === true
  const expireText = notifyEndDateTime ? formatDate(notifyEndDateTime) : ''
  const actionText = isRegistered
    ? expireText
      ? isAutoRenew
        ? `Gia hạn tự động vào ${expireText}`
        : `Hết hạn vào ${expireText}`
      : isAutoRenew
      ? 'Đang bật gia hạn tự động'
      : 'Chưa bật gia hạn tự động'
    : 'Nhận thông báo tự động khi có lỗi'

  return (
    <div className={`VehicleItem ${onClick ? 'VehicleItem_clickable' : ''} ${className}`.trim()} onClick={onClick} key={key}>
      <div className="VehicleItem_top">
        <div className="VehicleItem_top_left">
          <VehicleIcon className="VehicleItem_icon" />
          <div className="VehicleItem_main">
            <div className="VehicleItem_vehicleIdentity">{vehicleIdentity}</div>
            {isRegistered ? (
              <div
                className={`VehicleItem_registeredPackage ${
                  currentRegisteredPackageMode === 2 ? 'VehicleItem_registeredPackage_mode_2' : 'VehicleItem_registeredPackage_mode_1'
                }`}>
                {currentRegisteredPackageMode === 2 ? (
                  <>
                    <IconGreenCheck className="VehicleItem_registeredPackage_checkIcon" />
                    <span className="VehicleItem_registeredPackage_text">{registeredPackageText}</span>
                  </>
                ) : (
                  <>
                    <SafeImage src={iconBell} className="VehicleItem_registeredPackage_bellIcon" />
                    <span className="VehicleItem_registeredPackage_text">{productName}</span>
                  </>
                )}
              </div>
            ) : null}
          </div>
        </div>
        <IconArrowRight
          onClick={(event) => {
            if (onClickArrowRight) {
              event.stopPropagation()
              onClickArrowRight?.(event)
            }
          }}
        />
      </div>

      <div className={`VehicleItem_action ${isRegistered ? 'VehicleItem_action_is_registered' : 'VehicleItem_action_not_registered'}`}>
        <div className="VehicleItem_action_text">{actionText}</div>

        <button
          type="button"
          className={`VehicleItem_action_button ${isRegistered ? 'VehicleItem_action_button_registered' : 'VehicleItem_action_button_unregistered'}`}
          onClick={(event) => {
            event.stopPropagation()
            onActionClick?.(event)
          }}>
          {isRegistered ? 'Quản lý' : 'Đăng ký'}
        </button>
      </div>
    </div>
  )
}

